<template>
  <v-container style="position: relative; max-width: calc(100% - 40px);">
    <div class="barra-fija-inferior hidden-md-and-up">
      <v-bottom-navigation dark>
        <v-btn @click="cambiaTab('escenario')">
          <span>{{ $t('personalizacion') }}</span>
        </v-btn>
        <v-btn @click="cambiaTab('resultados')">
          <span>Resultados</span>
        </v-btn>
      </v-bottom-navigation>
    </div>
    <proyecto-resultados-modal v-if="proyecto && modalResultadosMostar"
                               :activado="modalResultadosMostar"
                               :area="modalResultadosArea"
                               :tipo="modalResultadosTipo" :id="proyecto.id"
                               @cerrar="cerrarModalResultados"
                               @actualizadaPonderacion="obtenerResultados"/>

    <v-row no-gutters class="primary--text">
      <v-col cols="12">
        <v-breadcrumbs id="breadcrumbs" v-if="breadCrumbsItems.length > 0" :items="breadCrumbsItems" divider="|"
                       class="pl-0 hidden-sm-and-down"/>
      </v-col>
    </v-row>

    <v-row no-gutters class="primary--text">
      <v-col cols="12" md="3" :class="{'pr-6': $vuetify.breakpoint.mdAndUp}" v-show="mostarSecciones['escenario']"
             id="escenario" ref="escenario">
        <v-row no-gutters>
          <v-col cols="12">
            <div class="title mt-3 mb-0 font-weight-black">{{ $t('personalizacion') }}</div>
            <div class="caption hidden-sm-and-down pb-2">{{ $t('personalizacion_descrip') }}</div>
          </v-col>
        </v-row>

        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <div class="title font-weight-bold">
              {{ $t('escenarios') }}
              <v-icon v-if="escenarioValido" color="green">mdi-check</v-icon>
              <v-icon v-if="!escenarioValido" color="red">mdi-close</v-icon>
            </div>
            <v-divider color="secondary"/>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <escenario-componente v-if="proyecto" :escenario="proyecto.escenario"
                                  @change="escenarioActualizado"/>
          </v-col>
        </v-row>

        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <div class="title font-weight-bold">
              {{ $t('carac_reves') }}
            </div>
            <v-divider color="secondary"/>
          </v-col>
        </v-row>

        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <precios-componente v-if="proyecto" :proyecto="proyecto" @change="preciosActualizado"/>
          </v-col>
        </v-row>

        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <fabricacion-componente v-if="proyecto" v-model="fabricacionValida"
                                    :soluciones-constructivas="proyecto.solucionesConstructivas"/>
          </v-col>
        </v-row>

        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <declaracion-ambiental-componente v-if="proyecto"
                                              :soluciones-constructivas="proyecto.solucionesConstructivas"/>
          </v-col>
        </v-row>

        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <prestacionales-componente v-if="proyecto"
                                       :soluciones-constructivas="proyecto.solucionesConstructivas"/>
          </v-col>
        </v-row>

        <v-row no-gutters class="pb-2">
          <v-col cols="12">
            <div class="title font-weight-bold">
              {{ $t('solucion_constructiva') }}
            </div>
            <v-divider color="secondary"/>
          </v-col>
        </v-row>
        <solucion-constructiva-componente v-if="proyecto" :proyecto="proyecto" v-model="solucionesConstructivasValidas"
                                          :sol-cons-tipo="proyecto.tipoSolCons"/>
        <v-divider/>
        <v-row no-gutters class="pt-2">
          <v-col cols="12">
            <v-btn block rounded :disabled="!sePuedeRecalcular()" @click="actualizarProyecto()"
                   :loading="actualizandoProyecto" color="primary mt-2">
              {{ $t('recalcular') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="9" v-show="mostarSecciones['resultados']" id="resultados" ref="resultados">
        <v-row>
          <v-col cols="12">
            <p class="title mt-3 mb-0 font-weight-black">{{ $t('result_titulo') }}</p>
            <p class="caption mb-0">{{ $t('result_descrip') }}</p>
          </v-col>
        </v-row>

        <div v-if="resultados.length > 0 && selectSolucion">
          <v-row>
            <v-col cols="12" class="pr-3 pl-3 pt-0 pb-2">
              <select-resultados-componente :opciones="botonesTipoResultado" @change="cambiarBotonTipoResultado"/>
            </v-col>
          </v-row>
        </div>

        <v-row class="text-center" v-if="proyecto">

          <v-row v-if="cargandoResultados === false && proyecto.datosDesactualizados">
            <v-col cols="12">
              <v-alert type="info" color="warning" dense class="white--text">
                {{ $t('info_desactualizados') }}
                <v-btn depressed rounded :disabled="!sePuedeRecalcular()" @click="obtenerResultadosRecalculando()"
                       :loading="actualizandoProyecto" color="primary ml-4">
                  {{ $t('recalcular') }}
                </v-btn>
              </v-alert>
            </v-col>
          </v-row>

          <v-col cols="6" v-for="(solCons,i) in this.proyecto.solucionesConstructivas" :key="i">
                            <span class="body-1 font-weight-bold text-uppercase">
                                {{ titulo(solCons) }}
                            </span>
            <div>
              <btn-descripcion :id="solCons.id" :id_proyecto="proyecto.id" :disabled="cargandoResultados"/>
              <btn-pdf :id="solCons.id" :id-proyecto="proyectoId" :disabled="cargandoResultados"/>
            </div>
            <v-img :src="imgSolCons(solCons)" height="200px" max-height="200px" contain>
              <template v-slot:placeholder>
                <v-row align="center" justify="center" no-gutters class="py-4">
                  <v-skeleton-loader type="image" min-width="250px" max-width="250px"
                                     min-height="168px" max-height="168px"/>
                </v-row>
              </template>
            </v-img>
          </v-col>
        </v-row>

        <v-row v-if="cargandoResultados == false && resultados.length < 1">
          <v-col cols="12">
            <v-alert type="info" color="primary" class="white--text ma-12 display-1 pa-6">
              {{ $t('info_rellenar') }}
            </v-alert>
          </v-col>
        </v-row>

        <v-row v-if="cargandoResultados == true">
          <v-col cols="12 pa-12 display-1 text-center">
            {{ $t('cargando_resultados') }}
            <v-progress-circular indeterminate color="primary"/>
          </v-col>
        </v-row>


        <v-row v-if="cargandoResultados == true">
          <v-col cols="12 pa-12 display-1 text-center">
            {{ $t('cargando_resultados') }}
            <v-progress-circular indeterminate color="primary"/>
          </v-col>
        </v-row>

        <div v-if="cargandoResultados == false && resultados.length > 0">
          <v-row align="center" v-for="(resultado, i) in resultados" :key="i">
            <v-col cols="4" class="text-right resultados-puntuacion">
              <puntuacion-solucion-constructiva size="120" color="teal accent-3"
                                                :puntuacion="resultadoCompleto(resultado.completo, 0)"/>
            </v-col>
            <v-col cols="4" class="text-center resultados-ampliar">
              <v-chip class="primary--text" @click="verResultado(resultado)">
                <v-avatar color="teal">
                  <v-img :src="iconoResultado(resultado.area)" min-height="30px" min-width="30px"/>
                </v-avatar>
                <v-divider class="pa-2" style="border-right-color:#40108e;border-right-width: 1.7px" inset vertical/>
                <span class="pl-2">{{ resultado.area.nombre }}</span>
                <v-icon color="primary" right>mdi-chevron-right</v-icon>
              </v-chip>
            </v-col>
            <v-col cols="4" class="text-left resultados-puntuacion">
              <puntuacion-solucion-constructiva size="120"
                                                :puntuacion="resultadoCompleto(resultado.completo, 1)"/>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="12" class="text-right">
              <btn-informe-personalizado v-if="proyecto && tipoResultadoSeleccionado" :proyecto="proyecto"
                                         :tipo="tipoResultadoSeleccionado.btn"/>
              <btn-guardar v-if="proyecto && !proyecto.nombre" :id="proyecto.id"/>
            </v-col>
          </v-row>
        </div>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import PuntuacionSolucionConstructiva from "../../components/PuntuacionSolucionConstructiva";
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import EscenarioComponente from "./Componentes/Escenarios/EscenarioComponente";
import PreciosComponente from "./Componentes/SolucionConstructiva/Precios/PreciosComponente";
import FabricacionComponente from "./Componentes/SolucionConstructiva/Fabricacion/FabricacionComponente";
import SolucionConstructivaComponente from "./Componentes/SolucionConstructiva/SolucionConstructivaComponente";
import DeclaracionAmbientalComponente
  from "./Componentes/SolucionConstructiva/DeclaracionAmbiental/DeclaracionAmbientalComponente";
import PrestacionalesComponente from "./Componentes/SolucionConstructiva/Prestacionales/PrestacionalesComponente";
import ProyectoResultadosModal from "./Componentes/ProyectoResultadosModal";
import ImagenesServicio from "../../comunes/servicios/ImagenesServicio";
import DescripcionesServicio from "../../comunes/servicios/DescripcionesServicio";
import BtnPdf from "./Componentes/BtnPdf";
import BtnDescripcion from "./Componentes/BtnDescripcion";
import BtnGuardar from "./Componentes/BtnGuardar";
import BtnInformePersonalizado from "@/paginas/proyecto-detalles/Componentes/BtnInformePersonalizado";
import SelectResultadosComponente
  from "@/paginas/proyecto-detalles/Componentes/SelectResultadosComponente";

export default {
  name: 'ProyectoDetallesPagina',
  components: {
    BtnInformePersonalizado,
    SolucionConstructivaComponente,
    ProyectoResultadosModal,
    PuntuacionSolucionConstructiva,
    EscenarioComponente,
    PreciosComponente,
    FabricacionComponente,
    DeclaracionAmbientalComponente,
    PrestacionalesComponente,
    BtnPdf,
    BtnDescripcion,
    BtnGuardar,
    SelectResultadosComponente
  },
  data: () => ({
    proyecto: null,
    selectSolucion: null,
    escenarioValido: false,
    preciosValido: false,
    fabricacionValida: false,
    solucionesConstructivasValidas: false,
    breadCrumbsItems: [],
    actualizandoProyecto: false,
    resultados: [],
    cargandoResultados: false,
    modalResultadosMostar: false,
    modalResultadosArea: 'ambientales',
    modalResultadosTipo: 'dermis',
    mostarSecciones: {
      'escenario': true,
      'resultados': true
    },
    botonesTipoResultado: [
      {
        "btn": "dermis",
        "texto": "Ver resultados del material de revestimiento",
        "info": "Para el cálculo únicamente se consideran el material de recubrimiento y los materiales necesarios para su instalación (agarre, fijación, rejuntado, etc.) en 1m2 de solución constructiva."
      },
      {
        "btn": "completo",
        "texto": "Ver resultados de la solución constructiva completa",
        "info": "Para el cálculo se consideran todos los materiales que forman parte de 1m2 de solución constructiva, incluyendo material de revestimiento, agarre, nivelación, soportes, etc."
      }
    ],
    tipoResultadoSeleccionado: null
  }),
  mounted: function () {
    this.obtenerProyecto();
    this.obtenerResultados();
    this.tipoResultadoSeleccionado = this.botonesTipoResultado[1];
    this.selectSolucion = this.botonesTipoResultado[1];
    // eslint-disable-next-line no-console
    if (this.$vuetify.breakpoint.smAndDown) {
      this.mostarSecciones['resultados'] = false;
    }
  },
  computed: {
    proyectoId() {
      return parseInt(this.$route.params.id);
    }
  },
  methods: {
    cambiaTab(seccion) {
      Object.keys(this.mostarSecciones).forEach((index) => {
        this.mostarSecciones[index] = false;
      });
      this.mostarSecciones[seccion] = true;
    },
    titulo(solCons) {
      return DescripcionesServicio.materialSolCons(solCons);
    },
    cerrarModalResultados() {
      this.modalResultadosMostar = false;
    },
    calcularBreadCrumb() {
      if (typeof this.proyecto == "undefined" || !this.proyecto) {
        this.breadCrumbsItems = [];
        return;
      }

      let items = [];

      items.push(this.proyecto.tipoSolCons.tipo.nombre);
      items.push(this.proyecto.tipoSolCons.nombre);
      let cermico = DescripcionesServicio.materialSolConsCorto(this.proyecto.solucionesConstructivas[0]);
      let noCermico = DescripcionesServicio.materialSolConsCorto(this.proyecto.solucionesConstructivas[1]);

      items.push(`${cermico} vs ${noCermico}`);
      items.push("Resultados");

      let itemsBreadCrumb = [];
      items.forEach((item) => {
        let disabled = (item != "Resultados") ? false : true;
        itemsBreadCrumb.push({
          text: item,
          disabled: disabled,
          href: '/#/proyecto-nuevo'
        });
      });
      this.breadCrumbsItems = itemsBreadCrumb;
    },
    obtenerProyecto() {
      let proyectoId = this.$route.params.id;
      HttpHelper.get(`proyecto/${proyectoId}`)
          .then((proyecto) => {
            this.proyecto = proyecto;
          })
          .catch(() => {
          });
    },
    obtenerResultadosRecalculando() {
      this.cargandoResultados = true;
      let proyectoId = this.$route.params.id;
      HttpHelper.get(`proyecto/${proyectoId}/resultados`, {recalcular: true})
          .then((resultados) => {
            this.resultados = resultados;
            this.proyecto.datosDesactualizados = false;
          })
          .catch(() => {
          })
          .finally(() => this.cargandoResultados = false);
    },
    obtenerResultados() {
      this.cargandoResultados = true;
      let proyectoId = this.$route.params.id;
      HttpHelper.get(`proyecto/${proyectoId}/resultados`)
          .then((resultados) => {
            this.resultados = resultados;
          })
          .catch(() => {
          })
          .finally(() => {
            this.cargandoResultados = false;
          });
    },
    resultadoCompleto(completo, i) {
      if (completo.resultadosSolCons[i][this.tipoResultadoSeleccionado.btn] == "") return 0.0;

      return this.convertirAFlotante(completo.resultadosSolCons[i][this.tipoResultadoSeleccionado.btn]);
    },
    escenarioActualizado(esCorrecto) {
      this.escenarioValido = esCorrecto;
    },
    preciosActualizado(esCorrecto) {
      this.preciosValido = esCorrecto;
    },
    sePuedeRecalcular() {
      return this.escenarioValido && this.preciosValido && this.fabricacionValida
          && this.solucionesConstructivasValidas;
    },
    actualizarProyecto() {
      let proyectoId = this.$route.params.id;

      let urlBase = `proyecto/${proyectoId}/`;

      this.actualizandoProyecto = true;
      HttpHelper.post(`${urlBase}escenario`, this.proyecto.escenario)
          .then(() => {
            let promises = [];

            this.proyecto.solucionesConstructivas.forEach((cs) => {
              promises.push(HttpHelper.post(`${urlBase}solucion-constructiva/${cs.id}`, cs));
            });

            Promise.all(promises)
                .then(() => {
                  this.obtenerProyecto();
                  this.obtenerResultados();
                })
                .catch((error) => alert(error))
                .finally(() => this.actualizandoProyecto = false);
          })
          .catch((error) => {
            alert(error);
            this.actualizandoProyecto = false;
          });
    },
    estaSeleccionadoTipoResultado(btn) {
      if (this.tipoResultadoSeleccionado == null) return false;
      return btn.btn == this.tipoResultadoSeleccionado.btn;
    },
    cambiarBotonTipoResultado(btn) {
      this.tipoResultadoSeleccionado = btn;
    },
    convertirAFlotante(numero) {
      if (numero.includes(",")) numero = numero.replace(",", ".")
      return parseFloat(numero);
    },
    verResultado(resultado) {
      let area = resultado.area.clase.toLowerCase();
      let tipo = this.tipoResultadoSeleccionado.btn.trim().toLowerCase().replace("resultado", "");
      this.modalResultadosArea = area;
      this.modalResultadosTipo = tipo;
      this.modalResultadosMostar = true;
    },
    iconoResultado(area) {
      let icono = "prestacionales";
      if (area.clase.toLowerCase() == "ambientales") {
        icono = "ambientales";
      } else if (area.clase.toLowerCase() == "economicos") {
        icono = "economicos";
      }

      return require(`../../assets/iconos/${icono}.png`);
    },
    imgSolCons(solCons) {
      if (solCons.materialPersonalizado) return solCons.materialPersonalizado.imagen;

      let imgSolConsPath = ImagenesServicio.imgSolucionConstructiva(solCons);
      if (imgSolConsPath != null) return imgSolConsPath;

      return ImagenesServicio.imgTipoSolucionConstructivaS3(solCons.tipoSolucion.codigo);
    }
  },
  watch: {
    proyecto: {
      handler() {
        this.calcularBreadCrumb();
      },
      deep: true
    }
  },
};
</script>
<style lang="scss">
.barra-fija-inferior {
  background: #40108e;
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 50px;
  z-index: 1;
}

.v-application.md-down {
  .tipo-resultado {
    font-size: 11px !important;
  }
}

.v-application.sm-down {
  .tipo-resultado {
    font-size: 10px !important;
  }

  .resultados-ampliar.col-4 {
    width: 60% !important;
    max-width: 60% !important;
  }

  .resultados-puntuacion.col-4 {
    width: 20% !important;
    max-width: 20% !important;

    .v-progress-circular {
      height: 60px !important;
      width: 60px !important;
    }
  }

  .v-dialog {
    .v-card__title {
      font-size: 14px !important;
      line-height: 22px !important;
    }
  }

  .v-btn:not(.v-btn--round).v-size--large {
    height: 36px !important;
  }
}
</style>
<style lang="scss" scoped>
.v-alert.info {
  background-color: #f7d9cd !important;
  color: #40108e !important;

  .v-icon {
    color: #40108e;
    font-size: 30px;
    margin-top: 5px;
  }
}

.title {
  font-size: 1.2rem !important;
}

.info-breadcrumb {
  padding: 18px 12px;
  margin: 0;
}

.tipo-resultado {
  border: 3px solid #40108e !important;
  border-radius: 0 !important;
  font-size: 0.9rem;
  font-weight: bolder;
}

.v-application .secondary {
  border-color: #40108e !important;
}

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "personalizacion": "PERSONALIZACIÓN",
    "personalizacion_descrip": "En esta sección se debe definir las características del proyecto",
    "escenarios": "Escenarios",
    "carac_reves": "Características revestimiento",
    "solucion_constructiva": "Solución constructiva",
    "recalcular": "Recalcular",
    "result_titulo": "RESULTADOS EVALUACIÓN",
    "result_descrip": "En esta sección se presentan los resultados generales de la evaluación. Seleccione si los resultados que desea visualizar hacen referencia a:",
    "info_rellenar": "Se debe rellenar la personalización del proyecto para obtener los resultados",
    "cargando_resultados": "Cargando resultados",
    "info_btn_dermis_completa_0": "Para el cálculo únicamente se consideran el material de recubrimiento y los materiales necesarios para su instalación (agarre, fijación, rejuntado, etc.) en 1m2 de solución constructiva.",
    "info_btn_dermis_completa_1": "Para el cálculo se consideran todos los materiales que forman parte de 1m2 de solución constructiva, incluyendo material de revestimiento, agarre, nivelación, soportes, etc. ",
    "info_desactualizados": "Los resultados del proyecto pueden estar desactualizados, pulse el botón para recalcularlos"
  }
}
</i18n>
<!--@formatter:on-->